import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { ContactoComponent } from "./contacto/contacto.component";
import { CrearContactoComponent } from "./crear-contacto/crear-contacto.component";
import { CrearContactoDialog } from "./crear-contacto/crear-contacto-dialog/crear-contacto-dialog.component";
import { EditarContactoComponent } from "./editar-contacto/editar-contacto.component";
import { EditarContactoDialog } from "./editar-contacto/editar-contacto-dialog/editar-contacto-dialog.component";
import { EliminarContactoComponent } from "./eliminar-contacto/eliminar-contacto.component";
import { EliminarContactoDialog } from "./eliminar-contacto/eliminar-contacto-dialog/eliminar-contacto-dialog.component";
import { ListarContactosComponent } from "./listar-contactos/listar-contactos.component";
import { WhatsappContactoComponent } from "./whatsapp-contacto/whatsapp-contacto.component";
import { ContactoService } from "../../../providers/contacto.service";
import { TelefonoModule } from "../../../components/telefono/telefono.module";
import { AlertaContactoDialog } from "./alerta-contacto/alerta-contacto/alerta-contacto-dialog.component";
import { AlertasContactoComponent } from "./alerta-contacto/alerta-contacto.component";
import { RouterModule } from "@angular/router";
@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        RouterModule
    ],
    declarations: [
        ContactoComponent,
        CrearContactoComponent,
        CrearContactoDialog,
        EditarContactoComponent,
        EditarContactoDialog,
        EliminarContactoComponent,
        EliminarContactoDialog,
        ListarContactosComponent,
        WhatsappContactoComponent,
        AlertasContactoComponent,
        AlertaContactoDialog
    ],
    providers: [
        ContactoService,
    ],
    entryComponents: [
        CrearContactoDialog,
        EditarContactoDialog,
        EliminarContactoDialog,
        AlertaContactoDialog
    ],
    exports: [
        ContactoComponent,
        CrearContactoComponent,
        EditarContactoComponent,
        EliminarContactoComponent,
        AlertasContactoComponent,
        ListarContactosComponent,
        WhatsappContactoComponent,
    ]
})
export class ContactoModule { }
